import React from 'react';
import { Trash2, MessageCircle, Circle } from 'lucide-react';

const formatDate = (dateString) => {
  const date = new Date(dateString);
  const now = new Date();
  const yesterday = new Date(now);
  yesterday.setDate(yesterday.getDate() - 1);
  
  const isToday = date.toDateString() === now.toDateString();
  const isYesterday = date.toDateString() === yesterday.toDateString();
  
  if (isToday) {
    return new Intl.DateTimeFormat('en-US', {
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    }).format(date);
  } else if (isYesterday) {
    return 'Yesterday';
  } else if (now.getFullYear() === date.getFullYear()) {
    return new Intl.DateTimeFormat('en-US', {
      month: 'short',
      day: 'numeric'
    }).format(date);
  } else {
    return new Intl.DateTimeFormat('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    }).format(date);
  }
};

const truncateText = (text, maxLength = 75) => {
  if (text.length <= maxLength) return text;
  return text.substring(0, maxLength).trim() + '...';
};

const MessageList = ({ messages, onView, onDelete, selectedId }) => {
  return (
    <div className="overflow-hidden">
      <div className="divide-y divide-gray-100">
        {messages.map((message) => (
          <div 
            key={message.id} 
            className={`flex transition-all cursor-pointer hover:bg-blue-50 ${selectedId === message.id ? 'bg-blue-50' : ''}`}
          >
            <div 
              className="flex-1 p-4"
              onClick={() => onView(message)}
            >
              <div className="flex items-start mb-1">
                <div className="flex-1">
                  <div className="flex items-center">
                    <h3 className={`text-sm font-medium ${message.read ? 'text-gray-700' : 'text-black font-semibold'}`}>
                      {message.name}
                    </h3>
                    {!message.read && (
                      <span className="ml-2">
                        <Circle className="h-2 w-2 fill-blue-500 text-blue-500" />
                      </span>
                    )}
                  </div>
                  <p className="text-xs text-gray-500 mt-0.5">{message.email}</p>
                </div>
                <span className="text-xs text-gray-500 whitespace-nowrap ml-2">
                  {formatDate(message.createdAt)}
                </span>
              </div>
              <div className="flex items-start">
                <p className={`text-sm ${message.read ? 'text-gray-600' : 'text-gray-800'}`}>
                  {truncateText(message.message)}
                </p>
              </div>
            </div>
            <div className="flex items-center pr-3">
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  onDelete(message.id);
                }}
                className="p-2 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-full transition-colors"
                aria-label="Delete message"
              >
                <Trash2 className="h-4 w-4" />
              </button>
            </div>
          </div>
        ))}
      </div>
      
      {messages.length === 0 && (
        <div className="flex flex-col items-center justify-center py-12 text-center">
          <MessageCircle className="w-16 h-16 text-gray-300 mb-4" />
          <h2 className="text-xl font-medium text-gray-900 mb-1">No messages found</h2>
          <p className="text-gray-500">Try adjusting your search or filters</p>
        </div>
      )}
    </div>
  );
};

export default MessageList;